import { Grid, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { Table, ConfigProvider, Button as BtnAntD } from "antd";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditIcon from "@mui/icons-material/Edit";
import CreateUpdateRole from "./createUpdateRole";
import { EmptyData } from "../global/emptyData";
import { getRoles } from "store";
import { useCurrentHeight } from "utils/getScreenSize";
import { useCallback, useEffect, useState } from "react";

const GetAllUserLists = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [isForUpdate, setIsForUpdate] = useState(false);
  const [idForUpdate, setIdForUpdate] = useState(0);
  const [rolesData, setRolesData] = useState([]);

  const LoadData = useCallback(() => {
    if (getRoles.pending().type === "rolesClaims/get-roles/pending") {
      setIsLoading(true);
      setRolesData([]);
    }
    dispatch(getRoles()).then((data) => {
      if (data.type === "rolesClaims/get-roles/fulfilled") {
        setRolesData(data.payload.data);
        setIsLoading(false);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    LoadData();
  }, [dispatch, LoadData]);

  const renderEmptyData = () => (
    <EmptyData
      description="No Role Detected"
      action={showCreateUpdate}
      btnTitle="Add New Role"
      renderButton={true}
    />
  );

  //MODAL CREATE UPDATE
  const [openCreateUpdate, setOpenCreateUpdate] = useState(false);

  const handleCancel = () => {
    setOpenCreateUpdate(false);
    setIsForUpdate(false);
    setIdForUpdate(0);
  };
  const showCreateUpdate = () => {
    setOpenCreateUpdate(true);
  };
  const handleSubmit = () => {
    LoadData();
    setOpenCreateUpdate(false);
    setIdForUpdate(0);
    setIsForUpdate(false);
  };

  const handleUpdate = (id) => {
    setIsForUpdate(true);
    setIdForUpdate(id);
  };

  const columns = [
    {
      title: "Role Name",
      dataIndex: "name",
      key: "name",
      width: 100,
    },

    {
      title: "",
      dataIndex: "",
      key: "",
      width: 50,
      render: (rec, row) => (
        <>
          <BtnAntD
            size="small"
            type="text"
            style={{
              marginLeft: 2,
            }}
            icon={<EditIcon fontSize="inherit" />}
            className="bg-orange-600 text-white hover:enabled:bg-orange-400 hover:enabled:text-white"
            onClick={() => {
              handleUpdate(row);
              showCreateUpdate();
            }}
          >
            Update
          </BtnAntD>
        </>
      ),
    },
  ];

  return (
    <>
      <Grid container spacing={2}>
        {rolesData.length !== 0 ? (
          <Grid item xs={12} md={6} lg={6}>
            <Button
              startIcon={<AddOutlinedIcon />}
              variant="text"
              onClick={showCreateUpdate}
            >
              New Role
            </Button>
          </Grid>
        ) : null}
      </Grid>
      <ConfigProvider renderEmpty={renderEmptyData}>
        <Table
          rowClassName="odd:bg-slate-300"
          columns={columns}
          dataSource={rolesData}
          loading={isLoading}
          size="small"
          pagination={{
            showSizeChanger: true,
            showQuickJumper: true,
            position: ["bottomRight"],
          }}
          bordered={true}
          scroll={{ y: useCurrentHeight() - 330 }}
          style={{ marginTop: 10 }}
        />
      </ConfigProvider>
      <CreateUpdateRole
        handleCancel={handleCancel}
        openCreateUpdate={openCreateUpdate}
        handleSubmit={handleSubmit}
        isForUpdate={isForUpdate}
        idForUpdate={idForUpdate}
      />
    </>
  );
};
export default GetAllUserLists;
